import { MonthlyPrayerTimes } from '../types';

export const novemberPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "04:47",
    shoruk: "07:00",
    dhuhr: "11:36",
    asr: "13:29",
    maghrib: "16:03",
    isha: "18:00"
  },
  2: {
    fajr: "04:49",
    shoruk: "07:02",
    dhuhr: "11:36",
    asr: "13:27",
    maghrib: "16:00",
    isha: "17:58"
  },
  3: {
    fajr: "04:51",
    shoruk: "07:05",
    dhuhr: "11:36",
    asr: "13:25",
    maghrib: "15:58",
    isha: "17:56"
  },
  4: {
    fajr: "04:54",
    shoruk: "07:07",
    dhuhr: "11:36",
    asr: "13:24",
    maghrib: "15:55",
    isha: "17:54"
  },
  5: {
    fajr: "04:56",
    shoruk: "07:10",
    dhuhr: "11:36",
    asr: "13:22",
    maghrib: "15:53",
    isha: "17:52"
  },
  6: {
    fajr: "04:58",
    shoruk: "07:12",
    dhuhr: "11:36",
    asr: "13:20",
    maghrib: "15:51",
    isha: "17:50"
  },
  7: {
    fajr: "05:00",
    shoruk: "07:15",
    dhuhr: "11:37",
    asr: "13:18",
    maghrib: "15:48",
    isha: "17:48"
  },
  8: {
    fajr: "05:02",
    shoruk: "07:17",
    dhuhr: "11:37",
    asr: "13:17",
    maghrib: "15:46",
    isha: "17:46"
  },
  9: {
    fajr: "05:04",
    shoruk: "07:20",
    dhuhr: "11:37",
    asr: "13:15",
    maghrib: "15:44",
    isha: "17:44"
  },
  10: {
    fajr: "05:06",
    shoruk: "07:22",
    dhuhr: "11:37",
    asr: "13:13",
    maghrib: "15:41",
    isha: "17:42"
  },
  11: {
    fajr: "05:08",
    shoruk: "07:25",
    dhuhr: "11:37",
    asr: "13:12",
    maghrib: "15:39",
    isha: "17:40"
  },
  12: {
    fajr: "05:10",
    shoruk: "07:27",
    dhuhr: "11:37",
    asr: "13:10",
    maghrib: "15:37",
    isha: "17:39"
  },
  13: {
    fajr: "05:11",
    shoruk: "07:30",
    dhuhr: "11:37",
    asr: "13:09",
    maghrib: "15:35",
    isha: "17:37"
  },
  14: {
    fajr: "05:13",
    shoruk: "07:32",
    dhuhr: "11:37",
    asr: "13:07",
    maghrib: "15:32",
    isha: "17:35"
  },
  15: {
    fajr: "05:15",
    shoruk: "07:34",
    dhuhr: "11:37",
    asr: "13:06",
    maghrib: "15:30",
    isha: "17:34"
  },
  16: {
    fajr: "05:17",
    shoruk: "07:37",
    dhuhr: "11:38",
    asr: "13:04",
    maghrib: "15:28",
    isha: "17:32"
  },
  17: {
    fajr: "05:19",
    shoruk: "07:39",
    dhuhr: "11:38",
    asr: "13:03",
    maghrib: "15:26",
    isha: "17:31"
  },
  18: {
    fajr: "05:21",
    shoruk: "07:42",
    dhuhr: "11:38",
    asr: "13:01",
    maghrib: "15:24",
    isha: "17:29"
  },
  19: {
    fajr: "05:23",
    shoruk: "07:44",
    dhuhr: "11:38",
    asr: "13:00",
    maghrib: "15:22",
    isha: "17:28"
  },
  20: {
    fajr: "05:24",
    shoruk: "07:46",
    dhuhr: "11:38",
    asr: "12:59",
    maghrib: "15:20",
    isha: "17:27"
  },
  21: {
    fajr: "05:26",
    shoruk: "07:49",
    dhuhr: "11:39",
    asr: "12:58",
    maghrib: "15:19",
    isha: "17:25"
  },
  22: {
    fajr: "05:28",
    shoruk: "07:51",
    dhuhr: "11:39",
    asr: "12:57",
    maghrib: "15:17",
    isha: "17:24"
  },
  23: {
    fajr: "05:29",
    shoruk: "07:53",
    dhuhr: "11:39",
    asr: "12:55",
    maghrib: "15:15",
    isha: "17:23"
  },
  24: {
    fajr: "05:31",
    shoruk: "07:55",
    dhuhr: "11:39",
    asr: "12:54",
    maghrib: "15:13",
    isha: "17:22"
  },
  25: {
    fajr: "05:33",
    shoruk: "07:58",
    dhuhr: "11:40",
    asr: "12:53",
    maghrib: "15:12",
    isha: "17:21"
  },
  26: {
    fajr: "05:34",
    shoruk: "08:00",
    dhuhr: "11:40",
    asr: "12:52",
    maghrib: "15:10",
    isha: "17:20"
  },
  27: {
    fajr: "05:36",
    shoruk: "08:02",
    dhuhr: "11:40",
    asr: "12:51",
    maghrib: "15:09",
    isha: "17:19"
  },
  28: {
    fajr: "05:37",
    shoruk: "08:04",
    dhuhr: "11:41",
    asr: "12:51",
    maghrib: "15:07",
    isha: "17:18"
  },
  29: {
    fajr: "05:39",
    shoruk: "08:06",
    dhuhr: "11:41",
    asr: "12:50",
    maghrib: "15:06",
    isha: "17:17"
  },
  30: {
    fajr: "05:40",
    shoruk: "08:08",
    dhuhr: "11:41",
    asr: "12:49",
    maghrib: "15:05",
    isha: "17:16"
  }
};